var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCertificate = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 38,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#004B87",
    strokeWidth: 1.925,
    opacity: 0.5,
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M0 28.49h37.621V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.17 26.18v9.557l2.499-2.499 2.499 2.499V26.18"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.865,
    cy: 22.715,
    r: 4.043
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.437 28.76c.017-1.468.383-2.686 1.098-3.654.716-.968 1.744-1.637 3.086-2.006M4.184 28.76c-.017-1.468-.383-2.686-1.098-3.654C2.37 24.138 1.342 23.469 0 23.1M33.437 0c.017 1.468.383 2.687 1.098 3.654.716.968 1.744 1.637 3.086 2.006M4.184 0c-.017 1.468-.383 2.687-1.098 3.654C2.37 4.622 1.342 5.291 0 5.66"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M7.7 11.935h22.622M7.7 15.015h22.622M15.015 5.775h7.7"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCertificate);
export default ForwardRef;